import React, { useEffect, useState } from 'react';
import Loading from '../../../utils/Loading';
import {
    getOblasti,
    getPodkategorije,
    getPodkategorijeByKategorijaId,
    getSkupOblastiByPodkategorijaId,
    getSkupoviOblasti,
} from '../../../server/server-kategorije-tree';
import { notif } from '../../utils/util';
import { DragDropContext } from 'react-beautiful-dnd';
import { Droppable } from 'react-beautiful-dnd';
import { Draggable } from 'react-beautiful-dnd';
import { FaEdit } from 'react-icons/fa';
import AddOblastModal from './AddOblastModal';
import { useNavigate } from 'react-router-dom';
import { downloadStrukturaSablon, importStrukturaExcel, previewImportStrukturaExcel } from '../../../server/server-kviz';
function OblastHome() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [oblasti, setOblasti] = useState<any>([]);
    const [selectedKategorija, setSelectedKategorija] = useState<any>(null);
    const [selectedOblast, setSelectedOblast] = useState<any>(null);
    const [addOblastModalOpen, setAddOblastModalOpen] = useState(false);
    const [uploadingStruktura, setUploadingStruktura] = useState(false);
    const [strukturaErrors, setStrukturaErrors] = useState<any[]>([]);

    useEffect(() => {
        loadOblasti();
    }, []);

    const loadOblasti = async () => {
        const resp = await getOblasti();
        if (resp.status === 200) {
            setOblasti(resp.data);
        }
    };

    const closeAddOblastModal = () => {
        setSelectedOblast(null);
        setAddOblastModalOpen(false);
    };
    const openAddOblastModal = (item: any) => {
        setSelectedOblast(item);
        setAddOblastModalOpen(true);
    };

    const handleSablon = async () => {
        try {
            const resp: any = await downloadStrukturaSablon();
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.download = 'struktura-sablon.xlsx';
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error: any) {
            notif('Greška pri preuzimanju šablona');
        }
    };

    const handleStrukturaUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setUploadingStruktura(true);
        setStrukturaErrors([]);
        try {
            // prvo samo pregled - ništa se ne upisuje
            const preview = await previewImportStrukturaExcel(file);
            if (preview.status !== 200 && preview.status !== 201) {
                notif(preview.data?.message || 'Greška pri proveri Excel fajla');
                return;
            }
            if (!preview.data.success) {
                setStrukturaErrors(preview.data.errors);
                notif('Excel ima greške');
                return;
            }
            const { oblasti, podoblasti, lekcije } = preview.data;
            const confirmed = window.confirm(
                `Oblasti: ${oblasti.novo} novih, ${oblasti.izmena} izmena.\nPodoblasti: ${podoblasti.novo} novih, ${podoblasti.izmena} izmena.\nLekcije: ${lekcije.novo} novih, ${lekcije.izmena} izmena.\n\nPotvrdi uvoz?`,
            );
            if (!confirmed) return;

            const result = await importStrukturaExcel(file);
            if (result.status !== 200 && result.status !== 201) {
                notif(result.data?.message || 'Greška pri uvozu');
                return;
            }
            if (!result.data.success) {
                setStrukturaErrors(result.data.errors);
                notif('Excel ima greške');
                return;
            }
            notif(result.data.message);
            loadOblasti();
        } catch (error: any) {
            notif(error?.message || 'Greška pri uvozu Excel fajla');
        } finally {
            setUploadingStruktura(false);
            e.target.value = '';
        }
    };

    const openSingleOblast = (id: string) => {
        navigate(`/admin/oblast/${id}`);
    };

    return (
        <div className="p-5 h-full">
            <div className="h-full overflow-auto ">
                <div className="flex flex-row items-center justify-between h-[50px]">
                    <label className="text-[16px] leading-5 text-black700 font-bold  ">
                        Lista oblasti <span>(ukupno {oblasti.length})</span>{' '}
                    </label>
                    <div className="flex flex-row items-center gap-2">
                        <button
                            className="px-4 h-[48px] flex items-center justify-center bg-white border border-black200 rounded-[4px] text-[16px] text-black700 font-bold cursor-pointer"
                            onClick={handleSablon}
                        >
                            <p>Šablon strukture (Excel)</p>
                        </button>
                        <label
                            className={`px-4 h-[48px] flex items-center justify-center bg-white border border-black200 rounded-[4px] text-[16px] text-black700 font-bold cursor-pointer ${
                                uploadingStruktura ? 'opacity-50 cursor-not-allowed' : ''
                            }`}
                        >
                            <input type="file" accept=".xlsx,.xls" onChange={handleStrukturaUpload} className="hidden" disabled={uploadingStruktura} />
                            <p>{uploadingStruktura ? 'Učitavanje...' : 'Import strukture (Excel)'}</p>
                        </label>
                        <button
                            className={`px-5 h-[48px] flex items-center justify-center bg-white border border-black200 rounded-[4px] text-[18px] text-black700 font-bold cursor-pointer `}
                            onClick={(e) => openAddOblastModal(null)}
                        >
                            <p>Dodaj oblast</p>
                        </button>
                    </div>
                </div>
                {strukturaErrors.length > 0 && (
                    <div className="mt-2 p-4 bg-red-50 border border-red-300 rounded relative">
                        <button
                            onClick={() => setStrukturaErrors([])}
                            className="absolute top-2 right-2 w-10 h-10 flex items-center justify-center rounded-full text-red-700 hover:bg-red-200 text-2xl leading-none font-bold"
                            title="Zatvori"
                        >
                            ×
                        </button>
                        <p className="text-red-700 font-bold mb-2 pr-10">Greške u Excel fajlu:</p>
                        <div className="max-h-[300px] overflow-y-auto">
                            {strukturaErrors.map((err, index) => (
                                <div key={index} className="mb-3 p-3 bg-white border border-red-200 rounded">
                                    <p className="text-red-800 font-semibold">
                                        List {err.sheet}, red {err.row}
                                    </p>
                                    <ul className="list-disc ml-5 mt-1">
                                        {err.messages.map((msg: string, i: number) => (
                                            <li key={i} className="text-red-700 text-sm">
                                                {msg}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                <div className="grid grid-cols-6 gap-2 mt-2">
                    {oblasti.map((item: any, index: number) => {
                        return (
                            <div
                                className={` border border-black200 rounded-[4px] p-2 flex flex-row items-center justify-between cursor-pointer ${
                                    item.id === selectedKategorija?.id ? 'bg-blueSuperLight' : 'bg-white'
                                }`}
                                key={index}
                                onClick={() => openSingleOblast(item.id)}
                            >
                                <div className="w-full ">
                                    <p>
                                        Naziv: <span className="font-bold">{item.naziv}</span>
                                    </p>
                                    <p>
                                        Kategorija: <span className="font-bold">{item.kategorija ? item.kategorija?.naziv : '-'}</span>
                                    </p>
                                    <p>
                                        Podkategorija: <span className="font-bold">{item.podkategorija ? item.podkategorija?.naziv : '-'}</span>
                                    </p>
                                    <p>
                                        Skup oblasti: <span className="font-bold">{item.skupOblasti ? item.skupOblasti?.naziv : '-'}</span>
                                    </p>
                                    <div className="w-full flex flex-row items-center justify-between">
                                        <p>Redosled: {item.redosled}</p>
                                        <div
                                            className=" cursor-pointer p-2 "
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                openAddOblastModal(item);
                                            }}
                                        >
                                            <FaEdit style={{ width: 20, height: 20 }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <AddOblastModal modalIsOpen={addOblastModalOpen} closeModal={closeAddOblastModal} oblastId={selectedOblast?.id} reloadOblastiList={loadOblasti} />
        </div>
    );
}

export default OblastHome;
